import { useEffect, useState } from 'react'
import { accounts } from './data'
import Login from './pages/Login'
import { ToastContainer, toast } from "react-toastify";
import { currency } from './currency';

import Sidebar from './components/Sidebar'
import UserList from './components/UserList';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userAccount, setUserAccount] = useState(accounts);
  const [loggedUser, setLoggedUser] = useState();
  const [wish, setWish] = useState('');
  const [alert, setAlert] = useState('');
  const [alertView, setAlertView] = useState();
  const [openSidebar, setOpenSidebar] = useState(true)

  // Currency
  const [flag, setFlag] = useState('INR')

  // Delete User
  const [delUser, setDelUser] = useState('');
  const [delUserPswd, setDelUserPswd] = useState('');

  // Transfer Amount
  const [transferTo, setTransferTo] = useState('');
  const [transferAmount, setTransferAmount] = useState('');

  // Country Flag 
  const countryFlag = () => {
    const countryFlag = currency.find((curr) => curr.code === flag)
    return countryFlag.flag
  }
  // Country Symbol
  const currencySymbol = () => {
    const countryFlag = currency.find((curr) => curr.code === flag)
    return countryFlag.symbol
  }
  // Currency Convertor
  const currencyConvert = (amount) => {
    let value;
    if (flag === "INR") {
      value = 1 * amount
    } else if (flag === "GBP") {
      value = 1 * amount / 94
    } else {
      value = 1 * amount / 85
    }
    return value
  }
  // Total Balance
  function totalBalance() {
    const total = loggedUser.map((user) => user.movements.reduce((cur, abs) => abs.moves + cur, 0))
    return total;
  }
  // Total Display
  const totalDisplay = () => {
    const output = currencySymbol() + currencyConvert(totalBalance()).toFixed(2);
    return output
  }
  // Positive Transaction
  const positiveTransaction = () => {
    const total = loggedUser.map((user) => user.movements.reduce((acc, cur) => cur.moves > 0 ? acc + cur.moves : acc, 0))
    const output = currencySymbol() + currencyConvert(total).toFixed(2);
    return output
  }
  // Negative Transaction
  const negativeTransaction = () => {
    const total = loggedUser.map((user) => user.movements.reduce((acc, cur) => cur.moves < 0 ? acc + cur.moves : acc, 0))
    const output = currencySymbol() + Math.abs(currencyConvert(total).toFixed(2));
    return output
  }
  // Alert Message
  const alertMessage = (msg, num) => {
    setAlert(msg);
    setAlertView(num)
    const getAlert = setTimeout(() => {
      setAlert('');
    }, 2000)
    return () => clearTimeout(getAlert)
  }

  // Delete User
  const handleUserDelete = (e) => {
    e.preventDefault();
    if (loggedUser.find((user) => user.userName === delUser && user.password === delUserPswd)) {
      const getNotify = setTimeout(() => {
        const updates = userAccount.map((acc) => acc.userName === delUser && acc.password === delUserPswd ? { ...acc, status: false } : acc);
        setUserAccount(updates)
        setIsLoggedIn(false)
      }, 3000)
      toast.success("Account closed successfully!");
      return () => clearTimeout(getNotify)
    } else {
      alertMessage('Something is wrong!', 2);
      setDelUser('')
      setDelUserPswd('')
    }
  }
  // Debit AMount
  const debitAmount = () => {
    const activeUser = loggedUser[0].userName;
    const transferValue = Number(transferAmount);
    setUserAccount((userAccount) => userAccount.map((user) => user.userName === activeUser ? { ...user, movements: [...user.movements, { transactionDate: new Date(), moves: -transferValue }] } : user))
    setLoggedUser((loggedUser) => loggedUser.map((user) => user.userName === activeUser ? { ...user, movements: [...user.movements, { transactionDate: new Date(), moves: -transferValue }] } : user))
  }
  // Credit Amount
  const creditAmount = () => {
    const transferValue = Number(transferAmount);
    setUserAccount((userAccount) => userAccount.map((user) => user.userName === transferTo ? { ...user, movements: [...user.movements, { transactionDate: new Date(), moves: transferValue }] } : user))
  }
  // Transfer Amount
  const handleTransferMoney = (e) => {
    e.preventDefault();
    const currentBalance = totalBalance();
    const transferValue = Number(transferAmount);
    const receiver = userAccount.find((user) => user.userName === transferTo);
    if (transferValue > 0 && receiver && transferValue <= currentBalance) {
      debitAmount()
      creditAmount()
    } else {
      alertMessage('Something is wrong!', 1);
    }
    setTransferAmount('')
    setTransferTo('')
  }
  // Data Manage
  const dateManage = (now) => {
    let date = now.getDate();
    let month = now.getMonth();
    let year = now.getFullYear();
    const dateFormat = `${date}/${month + 1}/${year}`;
    return dateFormat;
  };

  // First Letter Caps
  const firstLetterCaps = (text) => {
    const word = text.slice(0, 1).toUpperCase() + text.slice(1, text.length).toLowerCase()
    return word
  }
  // Wishing
  const wishing = () => {
    const date = new Date();
    const time = date.getHours();
    if (time >= 12) {
      setWish('Good Evening')
    }
    else if (time >= 19 && time <= 5) {
      setWish('Good Night')
    } else {
      setWish('Good Morning')
    }
  }
  useEffect(() => {
    wishing()
  }, [])

  return (
    <div className="App">
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      {isLoggedIn ? <div className='dashboard'>
        <ToastContainer autoClose={3000} />
        <Sidebar setOpenSidebar={setOpenSidebar} openSidebar={openSidebar} setLoggedUser={setLoggedUser} setIsLoggedIn={setIsLoggedIn} />
        <div className={`dashboard-content ${!openSidebar && "sider-open"}`}>
          <div className='header'>
            <div className='user-details'>
              <p>{wish}</p>
              <h2>
                <img src={loggedUser[0].photo} alt='avatar' className='avatar' />
                {loggedUser[0].name}
              </h2>
            </div>
            <button className='logout-btn' onClick={() => (setLoggedUser(), setIsLoggedIn(false))}>Logout</button>
          </div>
          {/* <Header loggedUser={loggedUser} setLoggedUser={setLoggedUser} setIsLoggedIn={setIsLoggedIn} /> */}
          <div className='balance-data'>
            <div className='total-handle'>
              <div className='balance-details'>
                <div className='avail-amount'>
                  <h5>Total Balance</h5>
                  <h2>{totalBalance() >= 0 ? "" : "-"}{totalDisplay()}</h2>
                </div>
                <div className='currency'>
                  <img src={countryFlag()} alt='' />
                  <select value={flag} onChange={(e) => setFlag(e.target.value)}>
                    <option value='INR'>INR</option>
                    <option value='GBP'>EUR</option>
                    <option value='USD'>USD</option>
                  </select>
                </div>
              </div>
              <div className='transaction-type'>
                <p>In: <span className='clr-green'>{positiveTransaction()}</span></p>
                <p>Out: <span className='clr-red'>{negativeTransaction()}</span></p>
              </div>
              <div className='delete-user'>
                <h3>Transfer Money</h3>
                {alertView === 1 && <p className='clr-red'>{alert}</p>}
                <form onSubmit={handleTransferMoney} className='delete-form'>
                  <select value={transferTo} onChange={(e) => setTransferTo(e.target.value)}>
                    <option value="select">Select</option>
                    {userAccount.map((acc, i) => acc.userName !== loggedUser[0].userName && <option value={acc.userName} key={i}>{firstLetterCaps(acc.userName)}</option>)}
                  </select>
                  <input
                    type='text'
                    placeholder='Enter amount'
                    value={transferAmount} onChange={(e) => setTransferAmount(e.target.value)} />
                  <button className='transfer-btn'>Transfer</button>
                </form>
              </div>
              <div className='delete-user'>
                <h3>Close account</h3>
                {alertView === 2 && <p className='clr-red'>{alert}</p>}
                <form onSubmit={handleUserDelete} className='delete-form'>
                  <input
                    type='text'
                    placeholder='Enter username'
                    value={delUser}
                    onChange={(e) => setDelUser(e.target.value)} />
                  <input
                    type='password'
                    placeholder='Enter password'
                    value={delUserPswd}
                    onChange={(e) => setDelUserPswd(e.target.value)} />
                  <button className='close-btn'>Close</button>
                </form>
              </div>
              <div className='web-view'>
                <UserList userAccount={userAccount} />
              </div>
            </div>
            <div className='transaction-data'>
              <div className=''>
                <h2>Transactions</h2>
                {loggedUser.map((user) => user.movements.length > 0 ? user.movements.slice().reverse().map((move, i) => <div key={i} className='movement-list'>
                  <p className={`${move.moves > 0 ? "positive" : "negative"}`}>{move.moves > 0 ? "Deposit" : "Withdrawal"}</p>
                  <span>{dateManage(move.transactionDate)}</span>
                  <h4>{move.moves > 0 ? "" : "-"}{currencySymbol()}{currencyConvert(Math.abs(move.moves)).toFixed(2)}</h4>
                </div>) : <h3>No transaction available</h3>)}
              </div>
              {/* <AllTransactions loggedUser={loggedUser} dateManage={dateManage} currencySymbol={currencySymbol} currencyConvert={currencyConvert} /> */}
              <div className='mob-view'>
                <UserList userAccount={userAccount} />
              </div>
            </div>
          </div>
        </div>
      </div> : <Login
        userAccount={userAccount}
        setUserAccount={setUserAccount}
        setLoggedUser={setLoggedUser}
        setIsLoggedIn={setIsLoggedIn} />
      }
    </div>
  );
}

export default App;
